import { API_URL } from "api/API";
import fetchImages from "api/display/fetchImages";
import Loader from "components/display/Loader";
import SkycamAnimation from "components/display/SkycamAnimation";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import styled from "styled-components";

const Container = styled.div`
  height: 100vh;
  /* background-color: #ffffff; */
`;

export default function Display() {
  const [render, setRender] = useState(false);
  const [error, setError] = useState(false);
  const [sliceImages, setSliceImages] = useState<string[]>();
  const {data, isLoading} = useQuery({
    queryKey: [API_URL.DISPLAY.FETCH_IMAGES],
    queryFn: fetchImages,
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: true
  });

  useEffect(() => {
    if (!isLoading && data.data) {
      setSliceImages((data.data as string[]).slice(3800))
    }
  }, [isLoading, data])

  useEffect(() => {
    if (sliceImages) {
      const loadImages = async () => {
        try {
          await preloadImages(sliceImages);
          setRender(true);
        } catch {
          setError(true);
        }
      }
      loadImages();
    }
  }, [sliceImages]);

  if (!render || !sliceImages) {
    return <Container>
      <Loader />
    </Container>
  }
  
  return <Container>
    <SkycamAnimation images={sliceImages} />
  </Container>
}

const preloadImages = (images: string[]) => {
  return Promise.all(images.map((image) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = image;
      img.onload = () => resolve(img);
      img.onerror = reject;
    })
  }))
}